var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxTimeFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.243 2.243 0 5 0C7.757 0 10 2.243 10 5C10 7.757 7.757 10 5 10C2.243 10 0 7.757 0 5ZM1.00016 5.00016C1.00016 7.20566 2.79466 9.00016 5.00016 9.00016C7.20566 9.00016 9.00016 7.20566 9.00016 5.00016C9.00016 2.79466 7.20566 1.00016 5.00016 1.00016C2.79466 1.00016 1.00016 2.79466 1.00016 5.00016Z",
    fill: "#74788D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.5H4.5V5.207L6.1465 6.8535L6.8535 6.1465L5.5 4.793V2.5Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTimeFive);
export default __webpack_public_path__ + "static/media/bx-time-five.056f9b37d929c1a653d5d15fc41133a7.svg";
export { ForwardRef as ReactComponent };